import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import it from './locales/it.json';
import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import { LANGUAGE_CODES } from './languages';

// Initial language for the login screen: last device choice, else Italian.
const initialLang = (() => {
  const saved = localStorage.getItem('rmp_login_lang');
  return LANGUAGE_CODES.includes(saved) ? saved : 'it';
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      es: { translation: es },
      en: { translation: en },
      fr: { translation: fr },
      pt: { translation: pt },
      zh: { translation: zh },
    },
    lng: initialLang,
    fallbackLng: 'it',
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
